module.exports = __webpack_public_path__ + "img/logo_login_photo@2x.fe214d62.png";